import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const DispatchImageReservationService = {
    getCauses: async () => axios.get(API_URL + `/dispatch_image_reservation/causes`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err })
}

export default DispatchImageReservationService;